export const APP_LOADING = 'APP_LOADING';
export const APP_ADVISOR_KEY = 'APP_ADVISOR_KEY';
export const APP_ADVISOR = 'APP_ADVISOR';
export const APP_APPLICATION_STATE = 'APP_APPLICATION_STATE';
export const APP_SPINNER = 'APP_SPINNER';